import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../forms/formikProvider.component';
import Modal from '../../modals/modal.component';
import Form from '../../forms/form.component';

import schema from './requestForm.schema';

import {
  hideSubmitRequestModal,
} from './store/actions';

import {
  successNotification,
  errorNotification,
} from '../../store/notificationActions';

import {
  submitRequest as submitRequestApi,
  submitRequestPublic as submitRequestPublicApi,
} from './api';

import { userSelector } from '../../store/selectors';
import { UserWithoutActiveFlagPropTypes } from '../../propTypes/users';

class SubmitRequestModal extends PureComponent {
  static propTypes = {
    hideSubmitRequestModal: PropTypes.func.isRequired,
    successNotification: PropTypes.func.isRequired,
    errorNotification: PropTypes.func.isRequired,
    isVisible: PropTypes.bool,
  };

  submitRequest = (formData, { setSubmitting, resetForm }) => {
    const { successNotification, errorNotification, hideSubmitRequestModal, user } = this.props;

    const submitRequest = user ? submitRequestApi : submitRequestPublicApi;

    submitRequest(formData)
      .then(() => {
        successNotification('Sending support request successful.');
        setSubmitting(false);
        hideSubmitRequestModal();
        resetForm();
      })
      .catch(() => errorNotification('Sending support request failed.'));
  };

  renderModal = ({ formik, schema }) => {
    const { isVisible, hideSubmitRequestModal } = this.props;

    return (
      <Modal
        title="Submit a Request"
        closeAction={hideSubmitRequestModal}
        dismissAction={hideSubmitRequestModal}
        dismissText="Cancel"
        submitText="Submit"
        submitAction={formik.handleSubmit}
        isVisible={isVisible}
        isSubmitting={formik.isSubmitting}
      >
        <Form
          formik={formik}
          schema={schema}
        />
      </Modal>
    );
  };

  render() {
    return (
      <FormikProvider
        schema={schema}
        onSubmit={this.submitRequest}
        render={this.renderModal}
      />
    );
  }
}

SubmitRequestModal.propTypes = {
  user: UserWithoutActiveFlagPropTypes,
};

const mapStateToProps = state => ({
  user: userSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideSubmitRequestModal,
    successNotification,
    errorNotification,
  }
)(SubmitRequestModal);
